export function formatCurrency(
  value: number,
  currency = "USD",
  options: Intl.NumberFormatOptions = {}
) {
  return new Intl.NumberFormat("default", {
    currency,
    currencyDisplay: "narrowSymbol",
    style: "currency",
    ...options,
  }).format(value);
}
